<template>
<div class="body">
  <div class="title">
    我的账号
  </div>
  <div>
    <el-card>
      <el-form ref="form" :model="editQuery" label-width="80px"  :rules="resetFormRules"   :label-position="labelPosition">
        <el-form-item label="用户名" label-width="10%">
          <el-input v-model="editQuery.username"  style="width: 30%" disabled></el-input>
        </el-form-item>
        <el-form-item label="头像" label-width="10%">
          <div class="imgbox" v-if="editQuery.userface !== ''">
            <img :src="editQuery.userface" alt="" class="imgs">
            <img src="../../assets/img/shanchu.png" mode="" class="close"
                   @click="closeImgs" v-if="editQuery.userface !== ''">
          </div>
          <el-upload
            v-if="editQuery.userface === ''"
            class="upload-demo"
            ref="upload"
            action="https://ydmxhapi.yundongm.cn:8099/service/admin/upload_pic"
            :on-progress="progress"
            :on-success="handleAvatarSuccess"
            :limit="1"
            :before-upload="beforeUpload"
            :on-exceed="handleExceed"
            list-type="picture"
            :data="{token:token}"
            name='pic'
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="旧密码" prop="userpass" label-width="10%">
          <el-input v-model="editQuery.userpass" placeholder="请输入旧密码" style="width: 30%" type="password"  auto-complete="off" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newuserpass" label-width="10%">
          <el-input v-model="editQuery.newuserpass" placeholder="请输入新密码" style="width: 30%" type="password"  auto-complete="off" show-password clearable></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="renewuserpass" label-width="10%">
          <el-input v-model="editQuery.renewuserpass" placeholder="请确认新密码" style="width: 30%" type="password"  auto-complete="off" show-password clearable></el-input>
        </el-form-item>
      </el-form>
      <button class="baocunshezhi" @click="baocun">保存设置</button>
    </el-card>
  </div>
</div>
</template>

<script>
import { xinxixiugai, adminInfo } from '@/api/login'

export default {
  name: 'index',
  data () {
    var validatePass = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      } else if (value.toString().length < 6 || value.toString().length > 18) {
        callback(new Error('密码长度为6-18位'))
      } else {
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.editQuery.newuserpass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      token: sessionStorage.getItem('token'),
      form: {},
      labelPosition: 'left',
      resetFormRules: {
        userpass: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
        ],
        newuserpass: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ],
        renewuserpass: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ]
      },
      editQuery: {
        userpass: '',
        newuserpass: '',
        renewuserpass: '',
        userface: ''
      }
    }
  },
  created () {
    this.ziliaoxiangqing()
  },
  methods: {
    closeImgs () {
      this.editQuery.userface = ''
    },
    ziliaoxiangqing () {
      const obj = {
        token: sessionStorage.getItem('token')
      }
      adminInfo(obj).then(({ data: res }) => {
        console.log('res', res)
        this.editQuery.username = res.user_name
        this.editQuery.userface = res.userface
      })
    },
    handleAvatarSuccess (response, file, fileList) {
      console.log('res', response)
      if (response.result === 1) {
        this.$message({
          message: response.msg,
          type: 'success',
          duration: '2000'
        })
        this.editQuery.userface = response.pic_url
        console.log('this.editQuery.userface ', this.editQuery.userface)
      }
    },
    beforeUpload (file) {
      console.log(file)
      const promise = new Promise((resolve) => {
        this.$nextTick(function () {
          resolve(true)
        })
      })
      return promise // 通过返回一个promis对象解决
    },
    progress (event, file, fileList) {
      console.log('event', event, 'file', file, 'fileList', fileList)
      // this.addquery.font_url.push({ name: file })
    },
    // 文件数量过多时提醒
    handleExceed () {
      // this.$message({ type: 'info', message: '最多支持5个附件上传' })
    },
    // doUpload
    ddUpload () {
      this.$refs.clearFile.dispatchEvent(new MouseEvent('click'))
    },
    getFile (el) {
      var file = el.target.files[0]// name: "dangqi1.png" || type: "image/png"
      var type = file.type.split('/')[0]
      console.log('type', type)
    },
    baocun () {
      const obj = {
        token: sessionStorage.getItem('token'),
        userpass: this.editQuery.userpass,
        newuserpass: this.editQuery.newuserpass,
        renewuserpass: this.editQuery.renewuserpass,
        userface: this.editQuery.userface
      }
      xinxixiugai(obj).then(({ data: res }) => {
        console.log('res', res)
        if (res.result === 1) {
          this.$message({
            message: res.msg,
            type: 'success',
            duration: '2000'
          })
        }
        if (res.result === 0) {
          this.$message({
            message: res.msg,
            type: 'error',
            duration: '2000'
          })
          return false
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.body{
  display: flex;
  flex-direction: column;
  .title{
    margin-left: 28px;
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
  }
  .baocunshezhi{
    width: 107px;
    height: 36px;
    opacity: 1;
    background: linear-gradient(135deg,#3d9aff, #3380f2);
    border-radius: 2px;
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: left;
    color: #ffffff;
    letter-spacing: 0px;
    border:none;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .file{
    display: none;
  }
  .imgbox{
    width: 88px;
    height: 88px;
    opacity: 1;
    background: rgba(0,0,0,0.00);
    border-radius: 5px;
    position: relative;
    .imgs{
      width: 100%;
      height: 100%;
    }
    .close {
      position: absolute;
      right: 0;
      top: 0;
      width: 20px;
      height: 20px;
      opacity: 1;
      background: #e54848;
      border-radius: 50%;
    }
  }
}
</style>
